import * as React from 'react';
import styled from 'styled-components';
import {
  color,
  ColorProps,
  compose,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';

export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 4.3168 11.6825 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654ZM11.117 7.04057C11.4063 6.75129 11.4063 6.28228 11.117 5.993C10.8277 5.70372 10.3587 5.70372 10.0695 5.993L7.25991 8.80255L5.93184 7.47448C5.64256 7.1852 5.17355 7.1852 4.88428 7.47448C4.595 7.76376 4.595 8.23277 4.88428 8.52205L6.73613 10.3739C7.0254 10.6632 7.49442 10.6632 7.78369 10.3739L11.117 7.04057Z"
        fill="currentColor"
      />
    </svg>
  );
});
export const IconSystemV2CourseCheck2 = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
